import { createFileRoute } from '@tanstack/react-router';
import { ObjectActivityTab } from '@/pages/workspaces/objects/object-detail/object-activity-tab';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/activity')({
  component: withRumPageRendered(ObjectActivityTab),
});
